export const RESIDENTS_DASHBOARD = "RESIDENTS_DASHBOARD"
